"use client";

import Button from '@/components/button';
import styles from './_hcp-back-to-top.module.scss';
import { useEffect, useState } from 'react';


export default function HcpBacktoTop({}) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    function onScroll() {
      setShow(window.scrollY > 500);
    }
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  function handleClick(e) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  if (!show) return null;

  return (
    <Button
      type="button"
      customClass={styles.backToTop}
      onClick={handleClick}
      data-gtm-event-category="Action"
      data-gtm-event-action="Click"
      data-gtm-event-label="Back to Top Button"
    >
      <span>
        Back to Top
      </span>
    </Button>
  );
}